export enum ReportRecommendation {
	PhysicalInspection = 1,
	AdministrativeInspection = 2,
	PhoneCall = 3,
	Monitoring = 4,
}
